<template>
  <v-dialog
    v-model="dialog"
    @keydown="seeToScroll"
    transition="dialog-bottom-transition"
    hide-overlay
    fullscreen
  >
    <template v-slot:activator="{ on, attrs }">
      <tr v-bind="attrs" v-on="on" class="cursor-pointer">
        <td class="grey--text text--darken-2 text-body-1 font-weight-normal">
          <div class="d-flex align-center justify-space-between">
            {{ title }}

            <span
              class="grey--text text--darken-2 text-body-1 font-weight-normal"
            >
              <v-btn
                color="grey lighten-4"
                width="30px"
                height="30px"
                depressed
                small
                fab
              >
                <v-icon color="primary lighten-2" size="16">
                  fa-external-link-alt
                </v-icon>
              </v-btn>
            </span>
          </div>
        </td>
      </tr>
    </template>
    <v-btn
      class="primary package-dialog-close-button"
      @click="dialog = false"
      icon
    >
      <v-icon class="white--text">fa-times</v-icon>
    </v-btn>

    <slot />
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    seeToScroll(event) {
      const dialog = document.getElementsByClassName("v-dialog--active")[0];

      if (event.keyCode === 38) {
        dialog.scroll({
          top: dialog.scrollTop - 30,
        });
      } else if (event.keyCode === 40) {
        dialog.scroll({
          top: dialog.scrollTop + 30,
        });
      }
    },
  },
};
</script>
